const customer = {
  maxPhoneNumbers: 3,
  maxAdresses: 2,
};

export default customer;
